const dashboardFeatures = [
  { icon: "ri-dashboard-3-line", label: "라이브 모니터링", desc: "연결된 모든 플랫폼의 활성 스트림을 완전히 가시화" },
  { icon: "ri-settings-4-line", label: "임계값 제어", desc: "스트림 유형별 감지 민감도 및 편집 파라미터 조정" },
  { icon: "ri-notification-3-line", label: "알림 센터", desc: "바이럴 순간, 처리 오류, 배포 상태에 대한 실시간 알림" },
  { icon: "ri-user-settings-line", label: "팀 워크플로우", desc: "프로듀서, 편집자, 배포 매니저를 위한 역할 기반 접근 권한" },
];

const queueItems = [
  { id: "Q-1042", clip: "세계 기록 순간", confidence: 96, eta: "12초", platform: "TikTok" },
  { id: "Q-1041", clip: "관중 반응 최고조", confidence: 91, eta: "34초", platform: "YouTube" },
  { id: "Q-1040", clip: "역전 하이라이트", confidence: 87, eta: "1분 8초", platform: "Reels" },
];

export default function DashboardSection() {
  return (
    <section id="dashboard" className="py-28 bg-[#0F1419] relative overflow-hidden">
      <div className="absolute top-1/3 right-0 w-96 h-96 rounded-full bg-[#00D9FF]/4 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#00D9FF] text-xs font-semibold uppercase tracking-widest mb-4 block" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
            06 / 대시보드 및 제어판
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-5" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            콘텐츠 파이프라인의 <span className="text-[#00D9FF]">지휘 센터</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
            라이브 스트림 모니터링, AI 파라미터 제어, 처리 대기열 관리, 배포 감독까지
            하나의 통합 인터페이스에서 실시간으로 처리합니다.
          </p>
        </div>

        <div className="bg-[#0A0E14] border border-white/10 rounded-2xl overflow-hidden mb-12">
          <div className="flex items-center gap-2 px-5 py-3 bg-[#1A1F2E]/50 border-b border-white/8">
            <div className="flex gap-1.5">
              <div className="w-3 h-3 rounded-full bg-[#EF4444]/60" />
              <div className="w-3 h-3 rounded-full bg-[#F59E0B]/60" />
              <div className="w-3 h-3 rounded-full bg-[#10B981]/60" />
            </div>
            <div className="flex-1 bg-[#0F1419] rounded-md px-4 py-1 mx-4 text-gray-600 text-xs text-center" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
              app.streamclip.ai/dashboard
            </div>
            <span className="flex items-center gap-1 text-xs text-[#10B981]" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
              <span className="w-1.5 h-1.5 rounded-full bg-[#10B981] animate-pulse inline-block" />
              스트림 3개 라이브
            </span>
          </div>

          <div className="flex" style={{ minHeight: "500px" }}>
            <div className="w-16 bg-[#0F1419] border-r border-white/8 flex flex-col items-center py-5 gap-5">
              {[
                { icon: "ri-dashboard-3-line", active: true },
                { icon: "ri-film-line", active: false },
                { icon: "ri-bar-chart-2-line", active: false },
                { icon: "ri-global-line", active: false },
                { icon: "ri-settings-4-line", active: false },
              ].map((item, i) => (
                <div key={i} className={`w-9 h-9 flex items-center justify-center rounded-xl cursor-pointer transition-colors ${item.active ? "bg-[#00D9FF]/15 text-[#00D9FF]" : "text-gray-600 hover:text-gray-400"}`}>
                  <i className={`${item.icon} text-lg`} />
                </div>
              ))}
            </div>

            <div className="flex-1 p-5">
              <div className="grid grid-cols-4 gap-4 mb-5">
                {[
                  { label: "활성 스트림", value: "3", trend: "+1", icon: "ri-broadcast-line", color: "#00D9FF" },
                  { label: "처리 대기열", value: "12", trend: "4개 완료", icon: "ri-loader-4-line", color: "#F59E0B" },
                  { label: "배포 준비 완료", value: "8", trend: "자동", icon: "ri-send-plane-line", color: "#10B981" },
                  { label: "오늘 클립 수", value: "47", trend: "+18%", icon: "ri-film-line", color: "#00D9FF" },
                ].map((m) => (
                  <div key={m.label} className="bg-[#0F1419] border border-white/8 rounded-xl p-4">
                    <div className="flex items-start justify-between mb-3">
                      <span className="text-gray-500 text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>{m.label}</span>
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className={`${m.icon} text-sm`} style={{ color: m.color }} />
                      </span>
                    </div>
                    <div className="text-2xl font-bold" style={{ color: m.color, fontFamily: "'JetBrains Mono', monospace" }}>{m.value}</div>
                    <div className="text-xs text-gray-600 mt-1">{m.trend}</div>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-3 gap-4">
                <div className="col-span-2 bg-[#0F1419] border border-white/8 rounded-xl p-4">
                  <div className="text-white text-xs font-semibold mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>라이브 스트림</div>
                  <div className="space-y-2">
                    {[
                      { name: "ChampionshipFinal_Stream", viewers: "142K", highlights: 4, cpu: 72 },
                      { name: "MusicFestival_Live", viewers: "89K", highlights: 2, cpu: 54 },
                      { name: "TechConf_Keynote", viewers: "34K", highlights: 1, cpu: 31 },
                    ].map((s) => (
                      <div key={s.name} className="flex items-center gap-3 bg-[#1A1F2E]/50 rounded-lg px-3 py-2.5">
                        <span className="w-2 h-2 rounded-full bg-[#10B981] animate-pulse shrink-0" />
                        <span className="flex-1 text-gray-300 text-xs truncate" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{s.name}</span>
                        <span className="text-[#00D9FF] text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{s.viewers}</span>
                        <span className="text-gray-600 text-xs">{s.highlights}개 클립</span>
                        <div className="w-16 h-1.5 bg-[#0A0E14] rounded-full overflow-hidden">
                          <div className="h-full bg-[#10B981] rounded-full" style={{ width: `${s.cpu}%` }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="bg-[#0F1419] border border-white/8 rounded-xl p-4">
                  <div className="text-white text-xs font-semibold mb-3" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>내보내기 대기열</div>
                  <div className="space-y-2">
                    {queueItems.map((q) => (
                      <div key={q.id} className="bg-[#1A1F2E]/50 rounded-lg px-3 py-2.5">
                        <div className="flex justify-between items-start mb-1.5">
                          <span className="text-gray-400 text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{q.id}</span>
                          <span className="text-[#F59E0B] text-xs" style={{ fontFamily: "'JetBrains Mono', monospace" }}>{q.eta}</span>
                        </div>
                        <div className="text-gray-300 text-xs truncate">{q.clip}</div>
                        <div className="mt-1.5 h-1 bg-[#0A0E14] rounded-full overflow-hidden">
                          <div className="h-full bg-gradient-to-r from-[#F59E0B] to-[#00D9FF] rounded-full animate-pulse" style={{ width: "40%" }} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-5">
          {dashboardFeatures.map((f) => (
            <div key={f.label} className="bg-[#0A0E14] border border-white/8 rounded-xl p-5 hover:border-[#00D9FF]/20 transition-all duration-300">
              <div className="w-9 h-9 flex items-center justify-center bg-[#00D9FF]/10 rounded-lg mb-4">
                <i className={`${f.icon} text-[#00D9FF] text-lg`} />
              </div>
              <div className="text-white font-semibold mb-2 text-sm" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{f.label}</div>
              <p className="text-gray-500 text-xs leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
